import styled from "@emotion/styled";
import { ClockCircleOutlined, DownOutlined } from "@ant-design/icons";
import { Dropdown, MenuProps } from "antd";
import { SellerReportPeriod } from "services/interface/sellerReport.interface";
import { formatPeriodLabel } from "utils/thaiDate";
import { sd } from "../tokens";

export const PERIOD_OPTIONS: { key: SellerReportPeriod; label: string }[] = [
  { key: "7d", label: "7 วัน" },
  { key: "30d", label: "30 วัน" },
  { key: "year", label: "ปีนี้" },
];

interface PeriodDropdownProps {
  period: SellerReportPeriod;
  onChange: (period: SellerReportPeriod) => void;
}

/**
 * ปุ่มเลือกช่วงเวลามุมขวาบน — เลือกได้ 3 ค่าตามที่ API รองรับ
 * แต่แสดงเป็นช่วงวันที่ พ.ศ. ที่คำนวณฝั่ง client ให้ตรงกับ getPeriodWindow() ของ backend
 */
const PeriodDropdown = ({ period, onChange }: PeriodDropdownProps) => {
  const items: MenuProps["items"] = PERIOD_OPTIONS.map((option) => ({
    key: option.key,
    label: (
      <OptionRow>
        <span>{option.label}</span>
        <OptionRange>{formatPeriodLabel(option.key)}</OptionRange>
      </OptionRow>
    ),
  }));

  return (
    <Dropdown
      trigger={["click"]}
      menu={{
        items,
        selectable: true,
        selectedKeys: [period],
        onClick: ({ key }) => onChange(key as SellerReportPeriod),
      }}
    >
      <Trigger type="button">
        <ClockCircleOutlined />
        <TriggerLabel>{formatPeriodLabel(period)}</TriggerLabel>
        <DownOutlined style={{ fontSize: 11, color: sd.subtle }} />
      </Trigger>
    </Dropdown>
  );
};

export default PeriodDropdown;

const Trigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: ${sd.cardBg};
  border: 1px solid ${sd.border};
  border-radius: 10px;
  box-shadow: ${sd.shadow};
  color: ${sd.ink};
  font-size: 14px;
  cursor: pointer;
  max-width: 100%;

  &:hover {
    border-color: ${sd.blue};
  }
`;

const TriggerLabel = styled.span`
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const OptionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-width: 200px;
`;

const OptionRange = styled.span`
  font-size: 12px;
  color: ${sd.subtle};
`;
